module.exports = __webpack_public_path__ + "img/flag-icon.ba6a6c04.png";